<template>
  <v-dialog persistent v-model="showDialog" max-width="480">
    <v-card outlined v-if="status === 'init'">
      <v-card-title>
        <span class="subtitle-1">Email ändern</span>
      </v-card-title>
      <v-card-text>
        <p v-if="userinfo && !email_verify_code">
          Ihre aktuelle Email Adresse lautet <b>{{ userinfo.attributes.email }}</b
          >. Wählen Sie eine neue Email Adresse:
        </p>
        <v-form v-model="valid" ref="form" lazy-validation>
          <v-text-field
            outlined
            v-if="!show_user_exists_message"
            v-model="newEmail"
            :rules="emailRules"
            label="Neue Email Adresse"
            placeholder="alex@beispiel.de"
            required
            :disabled="email_verify_code"
            v-on:input="prop_email()"
          />
          <v-alert outlined dismissible v-model="show_user_exists_message" type="error" transition="scale-transition">
            Ein Nutzer mit der Email {{ newEmail }} existiert bereits.
          </v-alert>
        </v-form>
      </v-card-text>
      <v-card-actions>
        <v-btn text @click="discard">Abbrechen</v-btn>
        <v-btn v-if="!email_verify_code" text @click="onChangeEmail" color="primary" :disabled="!valid"
          >Email jetzt Ändern</v-btn
        >
      </v-card-actions>
    </v-card>
    <v-card outlined v-if="status === 'verifying'">
      <v-card-title>
        <span class="subtitle-1">Email ändern</span>
      </v-card-title>
      <v-card-text>
        <v-form v-model="valid" ref="form" lazy-validation>
          <p>
            Wir haben eine Email an die Adresse <b>{{ newEmail }}</b> mit einem Verifizierungscode geschickt. Dieser ist
            einen Tag lang gültig. Bitte geben Sie diesen ein, um die neue Email zu verifizieren.
          </p>
          <v-text-field
            outlined
            v-model="verificationCode"
            v-if="!show_code_mismatch_message"
            :rules="codeRules"
            label="Code"
            placeholder="000000"
            required
          />
          <v-alert outlined dismissible v-model="show_code_mismatch_message" type="error">
            Der eingegebene Code stimmt nicht mit dem gesendeten Code überein
          </v-alert>
        </v-form>
      </v-card-text>
      <v-card-actions>
        <v-btn text @click="discard">Abbrechen</v-btn>
        <v-btn text color="primary" :disabled="!valid" @click="onVerifyCode">
          Email Bestätigung abschließen
        </v-btn>
      </v-card-actions>
    </v-card>

    <v-card outlined v-if="status === 'finished'">
      <v-card-title>
        <span class="subtitle-1">Email ändern</span>
      </v-card-title>
      <v-card-text>
        <span><v-icon color="green">check</v-icon></span>
        <span class="ml-3">Ihre Email wurde erfolgreich geändert und bestätigt.</span>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import { Auth } from "aws-amplify";

function changeEmail(user, newEmail) {
  return Auth.updateUserAttributes(user, {
    email: newEmail,
  });
}

function verifyEmail(verificationCode) {
  return Auth.verifyCurrentUserAttributeSubmit("email", verificationCode);
}

function init_data() {
  return {
    valid: false,
    status: "init",
    newEmail: null,
    verificationCode: null,
    passwordVisible: false,
    show_user_exists_message: false,
    show_code_mismatch_message: false,
    email_verify_code: false,
    change_finished: false,
  };
}

export default {
  name: "ChangeEmailView",
  props: {
    showThis: Boolean,
  },
  watch: {
    showThis: function(st) {
      this.showDialog = st;
    },
    showDialog: function(show) {
      if (show === false) {
        this.$emit("discard");
      } else {
        this.reset_view();
      }
    },
  },
  mounted() {},
  data: () => Object.assign(init_data(), { showDialog: false }),
  computed: {
    userinfo() {
      return this.$store.state.originalStore.user_info;
    },
    emailRules() {
      return [
        (v) => !!v || "Email ist ein Pflichtfeld",
        (v) => /.+@.+\..+/.test(v) || "Feld muss eine Gültige Email enthalten",
        (v) => v !== this.userinfo.attributes.email || "Entspricht der alten Email. Geben Sie eine neue Email ein.",
      ];
    },
    passwordRules() {
      return {
        required: (value) => !!value || "Passwort ist ein Pflichtfeld",
        mincnt: (v) => (v && v.length >= 8) || "Mindestens 8 Zeichen",
        mincap: (v) => /[A-Z]/.test(v) || "Mindestens 1 Großbuchstabe",
        minnum: (v) => /[0-9]/.test(v) || "Mindestens 1 Ziffer",
        minspc: (v) =>
          /[\^$*.\[\]{}()?"!@#%&/\\,><':;|_~`]/.test(v) ||
          "Mindestens 1 Sonderzeichen (^ $ * . [ ] { } ( ) ? \" ! @ # % & / \ , > < ' : ; | _ ~ `)",
      };
    },
    codeRules() {
      return [(v) => !!v || "Code wird benötigt", (v) => (v && /^[0-9]{6}$/.test(v)) || "Code besteht aus 6 Ziffern"];
    },
  },
  methods: {
    reset_view() {
      Object.assign(this, init_data());
    },
    prop_email() {
      this.$root.$emit("email", this.newEmail);
    },
    discard() {
      this.showDialog = false;
    },
    async onChangeEmail() {
      if (this.$refs.form.validate()) {
        if (this.newEmail === this.userinfo.attributes.email) {
        }
        var user = await Auth.currentAuthenticatedUser();
        console.log("user", user);
        console.log("email", this.newEmail);

        Auth.updateUserAttributes(user, {
          email: this.newEmail,
        })
          .then((result) => {
            if (result === "SUCCESS") {
              this.status = "verifying";
            } else {
              console.error("unexpected result in changeEmail:", result);
            }
          })
          .catch((error) => {
            if (error.code && error.code === "AliasExistsException") {
              this.show_user_exists_message = true;
            } else {
              console.error(error);
            }
          });
      }
    },
    onVerifyCode() {
      console.log("this.verificationCode", this.verificationCode);
      Auth.verifyCurrentUserAttributeSubmit("email", this.verificationCode)
        .then((result) => {
          if (result === "SUCCESS") {
            this.status = "finished";
            setTimeout(() => {
              this.showDialog = false;
            }, 3000);
          } else {
            console.error("warning: unexpected result on onVerifyCode:", result);
          }
        })
        .catch((error) => {
          if (error.code === "CodeMismatchException") {
            this.show_code_mismatch_message = true;
          } else {
            console.error("unexpected error in onVerifyCode:", error);
          }
        });
    },
  },
};
</script>
